import { render } from "./StudentMessage.vue?vue&type=template&id=eb35d16e&scoped=true"
import script from "./StudentMessage.vue?vue&type=script&lang=js"
export * from "./StudentMessage.vue?vue&type=script&lang=js"

import "./StudentMessage.vue?vue&type=style&index=0&id=eb35d16e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb35d16e"]])

export default __exports__